import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import _ from 'lodash';
import * as homeActions from '../../features/home/redux/actions';
import { REST_API_PRIMAREY_KEY, REST_API, BelongsToReferenceField } from 'drapcode-constant';
import RefFieldsOptionSelect from '../data-connector/RefFieldsOptionSelect';
import { drapcodeIcon } from '../../common/custom/icon-library';
import { apiTypeImages, snakeCaseToTitleCase } from '../../common/utils/api_utils';
import { flattenObject } from '../../common/utils/jsonUtils';
import { iconForField } from '../../common/custom/icon-library';
import CustomInputWithIcon from '../../common/ui/CustomInputWithIcon';
import { filters } from '../data-connector/connectorUtils';

export class ReponseDataKeyMappingToCollectionField extends Component {
  static propTypes = {};

  state = {
    selectedCollection: null,
    openRequestModal: false,
  };

  toggleOpenRequestModal = () => {
    this.setState({ openRequestModal: !this.state.openRequestModal });
  };

  componentDidUpdate(prevProps) {
    if (this.props.selectedCollectionName !== prevProps.selectedCollectionName) {
      const { collections } = this.props.home;
      const selectedCollection = collections.find((collection) => {
        return collection.collectionName === this.props.selectedCollectionName;
      });
      this.setState({ selectedCollection });
    }
  }

  componentDidMount() {
    if (this.props.selectedCollectionName) {
      const { collections } = this.props.home;
      const selectedCollection = collections.find((collection) => {
        return collection.collectionName === this.props.selectedCollectionName;
      });
      this.setState({ selectedCollection });
    }
    console.log('compo did mount here', this.props);
  }

  collectionsOptions = () => {
    const { collections, inMemoryCollections } = this.props.home;
    let collectionsToSelect = [];
    if (collections && collections.length > 0) {
      collectionsToSelect = collections.map((e) => ({
        label: e.collectionTitle,
        value: e.collectionName,
      }));
    }
    return [...collectionsToSelect];
  };

  handleCollectionChange = (event) => {
    const { collections } = this.props.home;
    const selectedCollection = collections.find((collection) => {
      return collection.collectionName === event.target.value;
    });
    this.setState({ selectedCollection });
    this.props.handleChange('selectedCollectionName', event.target.value);
  };

  handleSelectedMapping = (evt) => {
    this.props.handleChange('selectedMapping', {
      ...this.props.selectedMapping,
      [evt.target.name]: evt.target.value,
    });
  };

  handleSelectedMappingForReferenceField = (name, value) => {
    this.props.handleChange('selectedMapping', { ...this.props.selectedMapping, [name]: value });
  };

  createApiSelect = (name, uniqueKeys) => {
    const { connectorType } = this.props;
    return (
      <div className="row align-middle">
        <div className="col-md-5 col-lg-5 col-sm-5 text-center">
          <select
            className="form-control form-control-sm custom-select-sm"
            name={name}
            value={this.props.selectedMapping[name]}
            onChange={this.handleSelectedMapping}
          >
            <option value="">Select Key</option>
            {uniqueKeys.map((field) => (
              <option key={field} value={field}>
                {field}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-1 col-lg-1 p-0 text-center mt-1">or</div>

        <div className="col-md-6 col-lg-6 col-sm-6 text-center">
          <input
            name={name}
            value={this.props.selectedMapping[name]}
            onChange={this.handleSelectedMapping}
            className="form-control form-control-sm"
          />
        </div>
      </div>
    );
  };

  filterAndShow = (field) => {
    //TODO:responseData will be passed to this
    const { responseData, projectId, selectedMapping, home, connectorType, itemsPath } = this.props;
    const { selectedCollection } = this.state;
    if (filters.includes(field.fieldName)) {
      return '';
    }

    let flattenObjectKeys = [];
    if (responseData) {
      const dataToProcess = itemsPath ? _.get(responseData[0], itemsPath) : responseData;
      const objectWithAllKeys =
        dataToProcess && Array.isArray(dataToProcess) ? Object.assign({}, ...dataToProcess) : {};
      flattenObjectKeys = Object.keys(flattenObject(objectWithAllKeys));
    }
    const { fields } = selectedCollection ? selectedCollection : '';
    const currentField = fields && fields.find((e) => e.fieldName === field.fieldName);
    if (currentField && BelongsToReferenceField.includes(currentField.type)) {
      return (
        <Accordion key={field.fieldName} allowZeroExpanded>
          <AccordionItem key={field.fieldName}>
            <AccordionItemHeading>
              <AccordionItemButton>
                <strong>{field.fieldTitle.en}</strong>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <RefFieldsOptionSelect
                selectedField={currentField}
                name={field.fieldName}
                value={selectedMapping[field.fieldName]}
                handleSelectedMapping={this.handleSelectedMappingForReferenceField}
                projectId={projectId}
                collections={home.collections}
                uniqueKeys={flattenObjectKeys}
                connectorType={connectorType}
              />
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
      );
    } else {
      return (
        <div className="row my-2 td-align-middle px-3" key={field.fieldName}>
          <div className="col-md-4 col-lg-4 col-sm-4">{field.fieldTitle.en}</div>
          <div className="col-md-8 col-lg-8 col-sm-8">
            {this.createApiSelect(field.fieldName, flattenObjectKeys)}
          </div>
        </div>
      );
    }
  };

  getPrimaryFiledTableRow = () => {
    //TODO:connectorType will be passed to this
    const { connectorType, responseData } = this.props;
    const { itemsPath } = this.state;
    let flattenObjectKeys = [];
    if (responseData) {
      const dataToProcess = itemsPath ? _.get(responseData[0], itemsPath) : responseData;
      console.log(
        '🚀 ~ file: ReponseDataKeyMappingToCollectionField.js:191 ~ ReponseDataKeyMappingToCollectionField ~ dataToProcess:',
        dataToProcess,
      );
      const objectWithAllKeys =
        dataToProcess && Array.isArray(dataToProcess) ? Object.assign({}, ...dataToProcess) : {};
      flattenObjectKeys = Object.keys(flattenObject(objectWithAllKeys));
    }
    return (
      <div className="row my-2 td-align-middle px-3" key={'sdds'}>
        <div className="col-md-4 col-lg-4 col-sm-4">
          Uniquely Identifiable Column * <br />
          <small>
            Please select any unique field/key
            <br />
            to identify record/column/document.
          </small>
        </div>
        <div className="col-md-8 col-lg-8 col-sm-8">
          {this.createApiSelect(REST_API_PRIMAREY_KEY, flattenObjectKeys)}
        </div>
      </div>
    );
  };

  showField = () => {
    const { selectedCollection } = this.state;
    const { connectorType, processResponseDataMapping, externalDatabase } = this.props;
    const image = apiTypeImages[connectorType];
    if (!selectedCollection) {
      return '';
    }
    const { fields } = selectedCollection ? selectedCollection : '';
    const refFields =
      fields && fields.filter((field) => BelongsToReferenceField.includes(field.type));
    const nonRefFields =
      fields && fields.filter((field) => !BelongsToReferenceField.includes(field.type));

    return (
      <>
        {processResponseDataMapping && processResponseDataMapping !== 'DO_NOT_PERSIST_DATA' && (
          <div className="col-6">
            <CustomInputWithIcon icon="select">
              <select
                name="customPrimaryKey"
                className="form-control form-control-sm custom-select-sm"
                value={this.props.customPrimaryKey}
                onChange={(e) => this.props.handleChange(e.target.name, e.target.value)}
                disabled={this.props.isDisableFields}
              >
                <option value="">Custom Primary Key Select Field</option>
                {fields
                  .filter((e) => !filters.includes(e.fieldName))
                  .map((field) => (
                    <option key={field.fieldName} value={field.fieldName}>
                      {field.fieldTitle.en}
                    </option>
                  ))}
              </select>
            </CustomInputWithIcon>
          </div>
        )}

        <div className="col-12">
          <div className="row px-3">
            <div className="col-md-4 col-lg-4 col-sm-4">
              <h5 className="border-bottom">
                <i className={`wb ${drapcodeIcon('collection')}`}></i>&nbsp;Collection Fields
              </h5>
            </div>
            <div className="col-md-8 col-lg-8 col-sm-8">
              <h5 className="border-bottom" style={{ lineHeight: '1.75em' }}>
                {connectorType ? (
                  <img
                    src={require(`../../common/dataSource/img/${image}`)}
                    width="18"
                    height="18"
                    className="no-wh"
                    alt={
                      connectorType === REST_API ? 'REST API' : snakeCaseToTitleCase(connectorType)
                    }
                  />
                ) : (
                  <i className={`wb ${drapcodeIcon('REST_API')}`}></i>
                )}
                &nbsp;
                {connectorType
                  ? connectorType === REST_API
                    ? 'REST API'
                    : snakeCaseToTitleCase(connectorType)
                  : 'Response'}
                &nbsp;Fields
              </h5>
            </div>
          </div>
          {this.getPrimaryFiledTableRow()}
          {nonRefFields && nonRefFields.map((field) => this.filterAndShow(field))}
          {refFields && refFields.map((field) => this.filterAndShow(field))}
        </div>
      </>
    );
  };

  // getSelectedPrimaryKey = (tableName) => {
  //   const { externalDatabase, home } = this.props;
  //   const { collections } = home ? home : '';
  //   const obj = collections[0];
  //   let { externalDatabaseId } = obj ? obj : '';
  //   let externalDatabaseItem = externalDatabase.find((el) => el.uuid === externalDatabaseId);
  //   let { completeData } = externalDatabaseItem ? externalDatabaseItem : {};
  //   let table = completeData.tables.find(
  //     (table) => formatCollectionAndFieldName(table.name) === tableName,
  //   );
  //   if (table && table.selectedPrimaryKey) {
  //     return { selectedPrimaryKey: table.selectedPrimaryKey };
  //   }
  //   return { selectedPrimaryKey: 'id' };
  // };

  render() {
    const { connectorType, processResponseDataMapping, externalDatabase } = this.props;
    // const result = this.getSelectedPrimaryKey(this.props.selectedCollectionName);
    return (
      <>
        <div className="col-6">
          <div className="form-group">
            <CustomInputWithIcon icon="text">
              <input
                name="itemsPath"
                onChange={(e) => this.props.handleChange(e.target.name, e.target.value)}
                value={this.props.itemsPath}
                className="form-control form-control-sm"
                placeholder="Response Data Items Path (Optional)"
              />
            </CustomInputWithIcon>
          </div>
        </div>
        <div className="col-6">
          <div className="form-group">
            <CustomInputWithIcon icon="select">
              <select
                name="selectedCollectionName"
                className="form-control form-control-sm custom-select-sm"
                value={this.props.selectedCollectionName}
                onChange={this.handleCollectionChange}
                disabled={this.props.isDisableFields}
              >
                <option value="">Select Collection To Map</option>
                {this.collectionsOptions().map((collection) => (
                  <option
                    key={collection.value}
                    value={collection.value}
                    disabled={collection.disabled}
                  >
                    {collection.label}
                  </option>
                ))}
              </select>
            </CustomInputWithIcon>
          </div>
        </div>
        {this.showField()}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    homeActions: bindActionCreators({ ...homeActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReponseDataKeyMappingToCollectionField);
